// base image.js — framework-neutral baseline. image is a thin subclass
// of file that adds a client-side <img> preview using URL.createObjectURL.
// File-picker semantics (change/remove/revert flow, already/temp/fileHolder
// visibility) are inherited verbatim from file. m8 ships its own per-tier
// image component (KTImageInput widget) and never loads this module.
const file = require('../file/file');

const image = Object.assign({}, file, {
    // Extend file's subelement contract with image-specific ones:
    //   widgetHolder — outer wrapper around preview + file chrome
    //   previewImg   — <img> displaying the current or newly-picked image
    subelements: Object.assign({}, file.subelements, {
        widgetHolder: false,
        previewImg: false,
    }),

    // Read from data-zit-initial-web-path on the file <input>. Populated by
    // readZAttributes() (declared on component). Used as the fallback src
    // when the user reverts/removes a picked file.
    initialWebPath: '',

    // Object URL of the last user-picked File, retained so revoke can
    // free the blob on next pick or on cancel/revert.
    _lastObjectUrl: null,

    // Initial previewImg src captured at boot. Used to restore the preview
    // when the user reverts a not-yet-saved pick (covers both "had an
    // existing image" and "empty placeholder" starting states).
    _initialPreviewSrc: '',

    init: function () {
        file.init.call(this);

        if (this.hasSubelement('previewImg')) {
            this._initialPreviewSrc = this.subelements.previewImg.src;
        }
    },

    // Called by file.init's change-event listener when the user picks a
    // file. Run file's bookkeeping first (filename label, visibility
    // toggles), then swap the preview to a blob URL of the picked File.
    inputChanged: function () {
        file.inputChanged.call(this);

        if (
            this.hasSubelement('previewImg') &&
            this.element.files &&
            this.element.files[0]
        ) {
            // Revoke the prior blob URL (if any) to free memory before
            // minting a new one.
            if (this._lastObjectUrl) {
                URL.revokeObjectURL(this._lastObjectUrl);
            }
            this._lastObjectUrl = URL.createObjectURL(this.element.files[0]);
            this.subelements.previewImg.src = this._lastObjectUrl;
        }
    },

    // Restore the preview to its initial src when the user cancels their
    // pick (revert) or removes the existing server file.
    removeCurrentFile: function (removeServerFile) {
        file.removeCurrentFile.call(this, removeServerFile);
        this._restorePreview();
    },

    reset: function () {
        file.reset.call(this);
        this._restorePreview();
    },

    // Swap the preview back to the initially-rendered src and discard any
    // outstanding blob URL.
    _restorePreview: function () {
        if (!this.hasSubelement('previewImg')) {
            return;
        }

        if (this._lastObjectUrl) {
            URL.revokeObjectURL(this._lastObjectUrl);
            this._lastObjectUrl = null;
        }
        this.subelements.previewImg.src = this._initialPreviewSrc;
    },
});

module.exports = image;
